import { useState } from 'react'
import { ActivityEvent, ErrorDetail, RequestDetail } from '../aiChatTypes'
import { getDotState, isErrorDetail, isRequestDetail, tryParseDetail } from '../aiChatFunctions'
import styles from './ActivityLogLine.module.css'

function ErrorDetailBlock({ d }: { d: ErrorDetail }) {
  return (
    <div className={styles.errorDetail}>
      <div className={styles.errorMeta}>
        {d.status !== undefined && (
          <span>status: <span className={styles.errorMetaVal}>{d.status}</span></span>
        )}
        {d.category && (
          <span>category: <span className={styles.errorMetaVal}>{d.category}</span></span>
        )}
      </div>
      {d.url && <div className={styles.errorUrl}>{d.url}</div>}
      {d.responseBody !== undefined && (
        <>
          <div className={styles.errorSection}>Response body</div>
          <div className={styles.errorBody}>{d.responseBody}</div>
        </>
      )}
      {d.requestBody !== undefined && (
        <>
          <div className={styles.errorSection}>Request body sent</div>
          <div className={styles.errorBody}>{JSON.stringify(d.requestBody, null, 2)}</div>
        </>
      )}
    </div>
  )
}

function RequestDetailBlock({ d }: { d: RequestDetail }) {
  return (
    <div className={styles.requestDetail}>
      {d.method && (
        <>
          <div className={styles.requestSection}>Method</div>
          <div className={styles.requestBody}>{d.method}</div>
        </>
      )}
      {d.url && (
        <>
          <div className={styles.requestSection}>URL</div>
          <div className={styles.requestBody}>{d.url}</div>
        </>
      )}
      {d.body && (
        <>
          <div className={styles.requestSection}>Body</div>
          <div className={styles.requestBody}>{JSON.stringify(d.body, null, 2)}</div>
        </>
      )}
    </div>
  )
}

export function ActivityLogLine({ event }: { event: ActivityEvent }) {
  const [open, setOpen] = useState(false)
  const dotState = getDotState(event)
  const hasDetail = !!event.detail

  const parsed = event.detail ? tryParseDetail(event.detail) : null

  const renderDetail = () => {
    if (!parsed) return <pre className={styles.detailBox}>{event.detail}</pre>
    if (isErrorDetail(parsed)) return <ErrorDetailBlock d={parsed} />
    if (isRequestDetail(parsed)) return <RequestDetailBlock d={parsed} />
    return <pre className={styles.detailBox}>{JSON.stringify(parsed, null, 2)}</pre>
  }

  return (
    <div className={styles.line}>
      <span className={styles.dot} data-state={dotState} />
      <div className={styles.body}>
        <div className={styles.header}>
          <span className={styles.text} data-state={dotState}>{event.text}</span>
          {hasDetail && (
            <button
              className={styles.toggle}
              data-state={dotState === 'error' ? 'error' : undefined}
              onClick={() => setOpen(v => !v)}
            >
              {open ? '▼ hide' : '▶ details'}
            </button>
          )}
        </div>
        {open && <div className={styles.detail}>{renderDetail()}</div>}
      </div>
    </div>
  )
}
